import { CountryRetrieve } from '../domain/Country'
import WallexService from './WallexService'
import countries from '../data/countries.json'

export default class CountryService extends WallexService {
    public static retrieve(): Array<CountryRetrieve> {
        return countries
    }
}
